import * as chatTypes from '../types/chatTypes';

const initialState = {
  loading: false,
  error: null,
  loaded: false,
  promo: null,
  bubble: null,
  secondaryPromos: [],
  kbArticleCount: 0,
  kbArticles: [],
};

const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    case chatTypes.LOAD_CHAT_PUBLIC_DATA_REQUEST:
      return { ...state, loading: true, error: null };
    case chatTypes.LOAD_CHAT_PUBLIC_DATA_SUCCESS: {
      const payload = action.payload || {};
      const d = payload.cfg && payload.cfg.success ? payload.cfg.data : null;
      const next = { ...state, loading: false, loaded: true, error: null };
      if (d) {
        if (d.promo) next.promo = d.promo;
        if (d.bubble) next.bubble = d.bubble;
        if (Array.isArray(d.secondaryPromos)) next.secondaryPromos = d.secondaryPromos;
        if (typeof d.kbArticleCount === 'number') next.kbArticleCount = d.kbArticleCount;
      }
      const kbPayload = payload.kb;
      next.kbArticles =
        kbPayload && kbPayload.success && Array.isArray(kbPayload.articles) ? kbPayload.articles : [];
      return next;
    }
    case chatTypes.LOAD_CHAT_PUBLIC_DATA_FAILURE:
      return { ...state, loading: false, loaded: true, error: action.payload };
    default:
      return state;
  }
};

export default chatReducer;

